import React from 'react';
import { Heart, Star } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const reviews = [{
  title: '"Mi hijo pasó de decir 3 palabras a más de 15."',
  text: 'Empecé el Tomo 3 cuando tenía 18 meses. En pocas semanas empezó a usar muchas más palabras y el pediatra notó el cambio. Por primera vez sentí que tenía un plan claro.',
  author: 'Luciana P., 28 años',
  location: 'Buenos Aires'
}, {
  title: '"Por fin dejé de improvisar."',
  text: 'Había probado actividades de Internet, pero todo era desordenado. Con el UltraPack supe exactamente qué hacer según la edad de mi hijo.',
  author: 'Valentina M., 31 años',
  location: 'Rosario'
}, {
  title: '"Las actividades entran perfecto en nuestra rutina."',
  text: 'Trabajo todo el día y pensé que no iba a poder seguir el método. Pero las actividades duran pocos minutos y usan cosas que ya tenemos en casa.',
  author: 'Florencia G., 35 años',
  location: 'Córdoba'
}, {
  title: '"El bono de la familia cambió todo."',
  text: 'Aprendí a responder a los comentarios sin discutir y hasta logré que los abuelos empezaran a hacer las actividades con mi hijo.',
  author: 'Carolina S., 33 años',
  location: 'Mendoza'
}, {
  title: '"Llegó al jardín mucho más seguro."',
  text: 'Hicimos las actividades del Bono Jardín sin Miedo antes de empezar las clases. El primer día pudo comunicarse con la maestra sin problemas y eso me dio muchísima tranquilidad.',
  author: 'Mariana T., 29 años',
  location: 'La Plata'
}, {
  title: '"Se nota que está pensado para familias argentinas."',
  text: 'Los ejemplos, las situaciones y hasta la forma de hablar se sienten cercanos. Parece hecho para nuestra realidad y eso hace toda la diferencia.',
  author: 'Agustina R., 27 años',
  location: 'Tucumán'
}];
export function Reviews() {
  return <section className="py-12 px-5 bg-white" data-id="element-184">
      <div className="text-center mb-10" data-id="element-185">
        <Heart className="w-10 h-10 text-red-500 mx-auto mb-4 fill-red-500" data-id="element-186" />
        <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-187">
          Lo que dicen las familias que ya empezaron
        </h2>
        <p className="text-gray-600" data-id="element-188">
          Más de{' '}
          <span className="font-bold text-violet-700" data-id="element-189">4.372 familias</span> ya
          eligieron el UltraPack para acompañar el desarrollo del habla de sus
          hijos.
        </p>
      </div>

      <div className="space-y-6" data-id="element-190">
        {reviews.map((review, index) => <Reveal key={index} delay={Math.min(index * 0.05, 0.25)} data-id="element-191">
            <div className="bg-stone-50 rounded-2xl p-6 border border-stone-200 transition-shadow hover:shadow-md" data-id="element-192">
              <div className="flex gap-1 mb-3" data-id="element-193">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-194" />)}
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-195">{review.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 italic" data-id="element-196">
                "{review.text}"
              </p>
              <div className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-197">
                — {review.author} · {review.location}
              </div>
            </div>
          </Reveal>)}
      </div>
    </section>;
}